module.exports = "/_next/static/images/alerts-mobile@3x-5e791c1f6a4716e0b843dc59094bead1.png";